<template>
  <div class="bg" v-show="show">
    <div class="wrapper">
      <!-- <img src="@assets/img/interview/close.svg" alt="close" class="close" @click="cancel()"> -->
      <img style="width: 50px; height 50px;margin: 40px auto 30px" src="@assets/img/material/notice.png" alt="notice">
      <p class="msg">
        <span>
          {{msg.title}}
        </span>
      </p>
      <p class="msgList">
        <span>{{msg.msg}}</span>
      </p>
      <div class="btns">
        <p class="confirm green" @click="confirm()">确认</p>
        <!-- <p class="cancel" @click="cancel()">取消</p> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'confirm',
  data() {
    return {
      show: true,
      msg: '',
      r: null
    }
  },
  methods: {
    open(m, r) {
      this.msg = m
      this.r = r
      this.show = true
    },
    close() {
      this.show = false
    },
    confirm() {
      this.r(true)
      this.close()
    },
    cancel() {
      this.r(false)
      this.close()
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/css/global.less';
  .bg {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.70);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1222;
  }
  .wrapper {
    min-height: 290px;
    width: 400px;
    background-color: @bg;
    box-shadow: 4px 4px 10px 0 rgba(5, 10, 15, 0.05);
    border-radius: 4px;
    z-index: 99998;
    display: flex;
    flex-direction: column;
    // justify-content: center;
    position: relative;
    .close {
      position: absolute;
      right: 28px;
      top: 18px;
      cursor: pointer;
    }
    .msg {
      width: 80%;
      // padding: 10px 20px;
      line-height: 26px;
      color: @dark;
      font-size: 20px;
      min-height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin:0 auto 14px;
      word-break: break-all; 
      font-weight: 500;
    }
    .msgList {
      width: 100%;
      // padding: 10px 20px;
      line-height: 18px;
      color: #829191;
      font-size: 14px;
      min-height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin:0 auto 32px;
      word-break: break-all;
    }
    .btns {
      height: 40px;
      align-items: center;
      display: flex;
      justify-content: center;
    }
    .confirm, .cancel {
      background-color: @bg;
      width: 120px;
      text-align: center;
      line-height: 40px;
      height: 40px;
      border-radius: 100px;
      border: 1px solid @green;
      color: @green;
      font-size: 14px;
      box-shadow: 2px 1px 8px 0 rgba(0, 0, 0, 0.1);
      cursor: pointer;
      &:hover {
        .btnHover;
      }
      &:active {
        .btnActive;
      }
    }
    .green {
      // margin-right: 20px;
      color: #fff;
      background-color: @green;
    }
  }
</style>
